import { Box, Typography } from '@mui/material';

import { TruncateText } from '../../../components/others/TruncateText';
import identificationTypes from "../../../data/identificationTypes.json";
import { getFieldContent } from '../../../utils/formatters';

const FieldRow = ({ col, item }) => {
    const content = getFieldContent(col, item, identificationTypes);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: 0, gap: 1 }}>
            <Typography variant="caption" className="field-label">
                {col.label}:
            </Typography>
            {col?.truncate ? (
                <TruncateText text={String(content)} limit={col.truncate} />
            ) : (
                <Typography>{content}</Typography>
            )}
        </Box>
    );
};

const ItemFieldDisplay = ({ isExpanded, columns, item }) => {
    const filteredColumns = columns.filter((col) => {
        if (!col.visible) return false;
        return isExpanded ? true : (col.filterable || col.showMobile);
    });

    return (
        <Box sx={{ minWidth: 0 }}>
            {filteredColumns.map((col, idx) => (
                <FieldRow key={col.id || idx} col={col} item={item} />
            ))}
        </Box>
    );
};

export default ItemFieldDisplay;